import ValidatorSelectField from "../../../FormFields/ValidatorSelectField";
import ValidatorTextField from "../../../FormFields/ValidatorTextField";
import MenuItem from "@mui/material/MenuItem";
import { insuranceNumberFieldDefault, requiredValidator } from "@/src/services/validationRules";
import { PARTNER_IRIS, PartnerIri } from "@/src/constants/partnerIris";
import BasePersonConsultingCheckin from "../../Common/Consulting/BasePersonConsultingCheckin.tsx";
import { getProductData } from "@/src/services/productService";
import { validateLvmAccount } from "@/src/services/partner/lvmService";

const partnerIrisRequiringInsurancePolicyNumber: readonly PartnerIri[] = [PARTNER_IRIS.AUXILIA, PARTNER_IRIS.LVM];
const partnerIrisRequiringProductSelection: readonly PartnerIri[] = [PARTNER_IRIS.AUXILIA, PARTNER_IRIS.DEURAG, PARTNER_IRIS.LVM];

export default function FamilyLawConsultingCheckin({ partner, idPrefix }: { partner: PartnerIri; idPrefix: string }) {
  return (
    <BasePersonConsultingCheckin
      idPrefix={idPrefix}
      partner={partner}
      getApiProductUri={(product) => getProductData(product, "apiUri")}
      getInitialProduct={() => "familyLawCase"}
      renderAdditionalFields={(isLoading) => (
        <>
          {partnerIrisRequiringProductSelection.includes(partner) && (
            <ValidatorSelectField label="Ihr Anliegen" name="product" validators={[requiredValidator("Bitte geben Sie Ihr Anliegen an.")]}>
              <MenuItem value={"alimony"}>Unterhalt</MenuItem>
              <MenuItem value={"death"}>Erbe/Todesfall</MenuItem>
              <MenuItem value={"familyLawCase"}>Anderes Thema</MenuItem>
            </ValidatorSelectField>
          )}
          {partnerIrisRequiringInsurancePolicyNumber.includes(partner) && (
            <ValidatorTextField
              label="Ihre Versicherungsscheinnummer"
              name="insurancePolicyNumber"
              validators={[
                requiredValidator(`Bitte geben Sie Ihre ${partner === PARTNER_IRIS.LVM ? "LVM" : "AUXILIA"} Versicherungsscheinnummer an.`),
                insuranceNumberFieldDefault,
              ]}
              disabled={isLoading}
            />
          )}
        </>
      )}
      {...(partner === PARTNER_IRIS.LVM && {
        preSubmitAction: validateLvmAccount,
      })}
    />
  );
}
